/**
 * ScreenOverlay Component
 * Darkens the screen during transitions
 */

export function ScreenOverlay({ isActive }) {
  return (
    <div className={`screen-overlay ${isActive ? 'active' : ''}`} />
  )
}

export default ScreenOverlay
